// import React, { useState, useEffect } from "react";
// import "./CrosswordGame.css";

// // Função simples para gerar a grade (algoritmo básico de cruzamentos)
// const generateGrid = (words, size = 12) => {
//   let grid = Array.from({ length: size }, () => Array(size).fill(""));

//   words.forEach((word, i) => {
//     let row = Math.floor(Math.random() * size);
//     let col = Math.floor(Math.random() * size);
//     let horizontal = Math.random() > 0.5;

//     if (horizontal && col + word.word.length < size) {
//       for (let j = 0; j < word.word.length; j++) {
//         grid[row][col + j] = grid[row][col + j] || word.word[j].toUpperCase();
//       }
//       word.start = { row, col, horizontal: true };
//     } else if (!horizontal && row + word.word.length < size) {
//       for (let j = 0; j < word.word.length; j++) {
//         grid[row + j][col] = grid[row + j][col] || word.word[j].toUpperCase();
//       }
//       word.start = { row, col, horizontal: false };
//     }
//   });

//   return grid;
// };

// const CrosswordGame = ({ words }) => {
//   const [grid, setGrid] = useState([]);
//   const [inputs, setInputs] = useState({});
//   const [validationMode, setValidationMode] = useState("manual"); // manual | slow
//   const [refreshKey, setRefreshKey] = useState(0);

//   useEffect(() => {
//     setGrid(generateGrid(words, 12));
//     setInputs({});
//   }, [refreshKey]);

//   const handleChange = (row, col, value, solution) => {
//     const key = `${row}-${col}`;
//     setInputs((prev) => ({ ...prev, [key]: value.toUpperCase() }));

//     if (validationMode === "slow") {
//       if (value.toUpperCase() === solution) {
//         document.getElementById(key).style.backgroundColor = "#b6f7b0"; // verde
//       } else {
//         document.getElementById(key).style.backgroundColor = "#f7b0b0"; // vermelho
//       }
//     }
//   };

//   const checkAnswers = () => {
//     grid.forEach((row, i) =>
//       row.forEach((cell, j) => {
//         const key = `${i}-${j}`;
//         if (cell !== "" && inputs[key]) {
//           document.getElementById(key).style.backgroundColor =
//             inputs[key] === cell ? "#b6f7b0" : "#f7b0b0";
//         }
//       })
//     );
//   };

//   return (
//     <div className="crossword-container">
//       <div className="controls">
//         <button onClick={() => setRefreshKey((k) => k + 1)}>🔄 Reiniciar Grade</button>
//         <button onClick={checkAnswers}>✅ Verificar</button>
//         <label>
//           <input
//             type="checkbox"
//             checked={validationMode === "slow"}
//             onChange={(e) => setValidationMode(e.target.checked ? "slow" : "manual")}
//           />
//           Validação Lenta
//         </label>
//       </div>

//       <div className="grid">
//         {grid.map((row, i) => (
//           <div key={i} className="row">
//             {row.map((cell, j) => {
//               const key = `${i}-${j}`;
//               return cell ? (
//                 <input
//                   key={key}
//                   id={key}
//                   maxLength={1}
//                   value={inputs[key] || ""}
//                   onChange={(e) => handleChange(i, j, e.target.value, cell)}
//                 />
//               ) : (
//                 <div key={key} className="empty"></div>
//               );
//             })}
//           </div>
//         ))}
//       </div>

//       <div className="clues">
//         <h3>Pistas</h3>
//         <ul>
//           {words.map((w, idx) => (
//             <li key={idx}>
//               <b>{idx + 1}.</b> {w.clue}
//             </li>
//           ))}
//         </ul>
//       </div>
//     </div>
//   );
// };

// export default CrosswordGame;

// import React, { useState, useEffect } from "react";
// import "./CrosswordGame.css";

// // =================== GERAÇÃO DE GRADE ===================
// const generateGrid = (words, size = 12) => {
//   let grid = Array.from({ length: size }, () => Array(size).fill(null));

//   words.forEach((word, i) => {
//     let row = Math.floor(Math.random() * size);
//     let col = Math.floor(Math.random() * size);
//     let horizontal = Math.random() > 0.5;

//     if (horizontal && col + word.word.length <= size) {
//       for (let j = 0; j < word.word.length; j++) {
//         grid[row][col + j] = {
//           letter: word.word[j].toUpperCase(),
//           wordIndex: i,
//           pos: j,
//           horizontal: true
//         };
//       }
//       word.start = { row, col, horizontal: true };
//     } else if (!horizontal && row + word.word.length <= size) {
//       for (let j = 0; j < word.word.length; j++) {
//         grid[row + j][col] = {
//           letter: word.word[j].toUpperCase(),
//           wordIndex: i,
//           pos: j,
//           horizontal: false
//         };
//       }
//       word.start = { row, col, horizontal: false };
//     }
//   });

//   return grid;
// };

// // =================== COMPONENTE PRINCIPAL ===================
// const CrosswordGame = ({ words }) => {
//   const [grid, setGrid] = useState([]);
//   const [inputs, setInputs] = useState({});
//   const [highlightedWord, setHighlightedWord] = useState(null);
//   const [validationMode, setValidationMode] = useState("manual");
//   const [refreshKey, setRefreshKey] = useState(0);

//   useEffect(() => {
//     setGrid(generateGrid(words, 12));
//     setInputs({});
//   }, [refreshKey]);

//   const handleChange = (row, col, value, cell) => {
//     const key = `${row}-${col}`;
//     const val = value.toUpperCase().slice(-1);
//     setInputs((prev) => ({ ...prev, [key]: val }));

//     // Aplicar feedback visual se modo lento
//     if (validationMode === "slow") {
//       const el = document.getElementById(key);
//       if (el) el.className = val === cell.letter ? "correct" : "wrong";
//     }

//     // Auto-salto para próxima célula da mesma palavra
//     const nextPos = cell.pos + 1;
//     const wordIndex = cell.wordIndex;
//     const nextCell = grid.flat().find(
//       (c) => c && c.wordIndex === wordIndex && c.pos === nextPos && c.horizontal === cell.horizontal
//     );
//     if (nextCell) {
//       const nextKey = `${nextCell.row ?? nextCell.rowIndex}-${nextCell.col ?? nextCell.colIndex}`;
//       const inputEl = document.getElementById(nextKey);
//       if (inputEl) inputEl.focus();
//     }
//   };

//   const handleKeyDown = (e, row, col) => {
//     const size = grid.length;
//     let nextRow = row;
//     let nextCol = col;

//     switch (e.key) {
//       case "Enter":
//       case "ArrowRight":
//         do { nextCol++; } while (nextCol < size && !grid[nextRow][nextCol]);
//         break;
//       case "ArrowLeft":
//         do { nextCol--; } while (nextCol >= 0 && !grid[nextRow][nextCol]);
//         break;
//       case "ArrowDown":
//         do { nextRow++; } while (nextRow < size && !grid[nextRow][nextCol]);
//         break;
//       case "ArrowUp":
//         do { nextRow--; } while (nextRow >= 0 && !grid[nextRow][nextCol]);
//         break;
//       default:
//         return;
//     }

//     if (nextRow >= 0 && nextRow < size && nextCol >= 0 && nextCol < size && grid[nextRow][nextCol]) {
//       const nextKey = `${nextRow}-${nextCol}`;
//       const nextInput = document.getElementById(nextKey);
//       if (nextInput) nextInput.focus();
//     }

//     e.preventDefault();
//   };

//   const checkAnswers = () => {
//     grid.forEach((row, i) =>
//       row.forEach((cell, j) => {
//         if (cell) {
//           const key = `${i}-${j}`;
//           const el = document.getElementById(key);
//           if (el) el.className = inputs[key] === cell.letter ? "correct" : "wrong";
//         }
//       })
//     );
//   };

//   const highlightWord = (wordIndex) => {
//     setHighlightedWord(wordIndex);
//   };

//   return (
//     <div className="crossword-container">
//       <div className="controls">
//         <button onClick={() => setRefreshKey((k) => k + 1)}>🔄 Reiniciar Grade</button>
//         <button onClick={checkAnswers}>✅ Verificar</button>
//         <label>
//           <input
//             type="checkbox"
//             checked={validationMode === "slow"}
//             onChange={(e) => setValidationMode(e.target.checked ? "slow" : "manual")}
//           />
//           Validação Lenta
//         </label>
//       </div>

//       <div className="grid">
//         {grid.map((row, i) => (
//           <div key={i} className="row">
//             {row.map((cell, j) =>
//               cell ? (
//                 <input
//                   key={`${i}-${j}`}
//                   id={`${i}-${j}`}
//                   maxLength={1}
//                   value={inputs[`${i}-${j}`] || ""}
//                   onChange={(e) => handleChange(i, j, e.target.value, cell)}
//                   onKeyDown={(e) => handleKeyDown(e, i, j)}
//                   className={highlightedWord === cell.wordIndex ? "highlighted" : ""}
//                 />
//               ) : (
//                 <div key={`${i}-${j}`} className="black-cell"></div>
//               )
//             )}
//           </div>
//         ))}
//       </div>

//       <div className="clues">
//         <h3>Pistas</h3>
//         <ul>
//           {words.map((w, idx) => (
//             <li
//               key={idx}
//               onClick={() => highlightWord(idx)}
//               style={{ cursor: "pointer" }}
//             >
//               <b>{idx + 1}.</b> {w.clue}
//             </li>
//           ))}
//         </ul>
//       </div>
//     </div>
//   );
// };

// export default CrosswordGame;

// jjjjjjjjjjjjjjjjjjjjjjjjjjjjjjjjjjjjjjjjjjjjjjjjjjjjjjjjjjjjjjjjjjjjjjjjjjjjjjjjjjjjjjjjjjjjjjjjjjjjjjjjjjjjjjjjjjjjjjjjjjjjjjjjjjjjjjjjjjjjjjjjjjjjjjjjjjjjjjjjjjjjjjjjjjjjjjjjjjjjjjjjjjjjjjjjjjjjjjjjjjjjjjjjjjjjjjjjjjjjjjjjjjjjjjjjjjjjjjjjjjjjjjjjjjjjjjjjjjjjjjjjjjjjjjjjjjjjjjjjjjjjjjjjjjjjjjjjjjjjjjjjjjjjjjjjjjjjjjjjjjjjjjjjjjjjjjjjjjjjjjjjjjjj

import React, { useState, useEffect } from "react";
import "./CrosswordGame.css";

// =================== GERAÇÃO DE GRADE ===================
const generateGrid = (words, initialSize = 20) => {
  let grid = Array.from({ length: initialSize }, () => Array(initialSize).fill(null));

  // Função para verificar se pode colocar a palavra
  const canPlace = (wordStr, row, col, horizontal) => {
    const len = wordStr.length;
    if (horizontal) {
      if (col + len > initialSize) return false;
      for (let j = 0; j < len; j++) {
        const cell = grid[row][col + j];
        if (cell && cell.letter !== wordStr[j].toUpperCase()) return false;
      }
    } else {
      if (row + len > initialSize) return false;
      for (let j = 0; j < len; j++) {
        const cell = grid[row + j][col];
        if (cell && cell.letter !== wordStr[j].toUpperCase()) return false;
      }
    }
    return true;
  };

  // Função para colocar a palavra
  const place = (wordStr, row, col, horizontal, wordIndex) => {
    const len = wordStr.length;
    if (horizontal) {
      for (let j = 0; j < len; j++) {
        const key = { wordIndex, pos: j, horizontal };
        if (!grid[row][col + j]) {
          grid[row][col + j] = { letter: wordStr[j].toUpperCase(), words: [key] };
        } else {
          grid[row][col + j].words.push(key);
        }
      }
    } else {
      for (let j = 0; j < len; j++) {
        const key = { wordIndex, pos: j, horizontal };
        if (!grid[row + j][col]) {
          grid[row + j][col] = { letter: wordStr[j].toUpperCase(), words: [key] };
        } else {
          grid[row + j][col].words.push(key);
        }
      }
    }
  };

  // Colocar a primeira palavra no meio horizontalmente
  if (words.length > 0) {
    const firstWord = words[0].word;
    const midRow = Math.floor(initialSize / 2);
    const midCol = Math.floor((initialSize - firstWord.length) / 2);
    place(firstWord, midRow, midCol, true, 0);
    words[0].start = { row: midRow, col: midCol, horizontal: true };
  }

  // Colocar as palavras restantes, preferindo interseções
  for (let i = 1; i < words.length; i++) {
    const wordStr = words[i].word;
    const len = wordStr.length;
    let possiblePositions = [];

    for (let horiz = 0; horiz < 2; horiz++) {
      const horizontal = !!horiz;
      for (let r = 0; r < initialSize; r++) {
        for (let c = 0; c < initialSize; c++) {
          if (canPlace(wordStr, r, c, horizontal)) {
            let intersectCount = 0;
            if (horizontal) {
              for (let j = 0; j < len; j++) {
                if (grid[r][c + j]) intersectCount++;
              }
            } else {
              for (let j = 0; j < len; j++) {
                if (grid[r + j][c]) intersectCount++;
              }
            }
            possiblePositions.push({ r, c, horizontal, intersectCount });
          }
        }
      }
    }

    if (possiblePositions.length === 0) {
      console.warn(`Não foi possível colocar a palavra ${wordStr}`);
      continue;
    }

    const maxIntersect = Math.max(...possiblePositions.map(p => p.intersectCount));
    let candidates = possiblePositions.filter(p => p.intersectCount === maxIntersect);
    if (candidates.length === 0) candidates = possiblePositions;
    const chosen = candidates[Math.floor(Math.random() * candidates.length)];
    place(wordStr, chosen.r, chosen.c, chosen.horizontal, i);
    words[i].start = { row: chosen.r, col: chosen.c, horizontal: chosen.horizontal };
  }

  // Cortar a grade para o tamanho mínimo
  let minRow = initialSize, maxRow = 0, minCol = initialSize, maxCol = 0;
  grid.forEach((row, r) => {
    row.forEach((cell, c) => {
      if (cell) {
        minRow = Math.min(minRow, r);
        maxRow = Math.max(maxRow, r);
        minCol = Math.min(minCol, c);
        maxCol = Math.max(maxCol, c);
      }
    });
  });

  if (minRow > maxRow) return []; // Nenhuma palavra colocada

  const height = maxRow - minRow + 1;
  const width = maxCol - minCol + 1;
  let newGrid = Array.from({ length: height }, () => Array(width).fill(null));

  grid.forEach((row, r) => {
    if (r >= minRow && r <= maxRow) {
      row.forEach((cell, c) => {
        if (c >= minCol && c <= maxCol) {
          newGrid[r - minRow][c - minCol] = cell;
        }
      });
    }
  });

  // Atualizar starts
  words.forEach(w => {
    if (w.start) {
      w.start.row -= minRow;
      w.start.col -= minCol;
    }
  });

  return newGrid;
};

// Atribuir números de pistas
const assignClueNumbers = (grid) => {
  let clueNumber = 1;
  grid.forEach((row, r) => {
    row.forEach((cell, c) => {
      if (cell) {
        const isAcrossStart = c === 0 || !row[c - 1];
        const isDownStart = r === 0 || !grid[r - 1][c];
        if (isAcrossStart || isDownStart) {
          cell.number = clueNumber++;
        }
      }
    });
  });
};

// =================== COMPONENTE PRINCIPAL ===================
const CrosswordGame = ({ words }) => {
  const [grid, setGrid] = useState([]);
  const [inputs, setInputs] = useState({});
  const [highlightedWord, setHighlightedWord] = useState(null);
  const [validationMode, setValidationMode] = useState("manual");
  const [refreshKey, setRefreshKey] = useState(0);

  useEffect(() => {
    const newGrid = generateGrid(words);
    assignClueNumbers(newGrid);
    setGrid(newGrid);
    setInputs({});
  }, [refreshKey, words]);

  const handleChange = (row, col, value) => {
    const key = `${row}-${col}`;
    const val = value.toUpperCase().slice(-1);
    setInputs((prev) => ({ ...prev, [key]: val }));

    const cell = grid[row][col];

    // Modo lento
    if (validationMode === "slow") {
      const el = document.getElementById(key);
      if (el) el.className = val === cell.letter ? "correct" : "wrong";
    }

    // Determinar o wordIndex atual
    const wordIndex = highlightedWord !== null ? highlightedWord : (cell.words[0] ? cell.words[0].wordIndex : null);
    if (wordIndex === null) return;

    // Encontrar a direção e pos
    const wordInfo = cell.words.find(w => w.wordIndex === wordIndex);
    if (!wordInfo) return;

    const nextPos = wordInfo.pos + 1;
    // Encontrar próxima célula na mesma palavra
    let nextRow = row;
    let nextCol = col;
    if (wordInfo.horizontal) {
      nextCol += 1;
    } else {
      nextRow += 1;
    }
    const nextKey = `${nextRow}-${nextCol}`;
    const nextEl = document.getElementById(nextKey);
    if (nextEl) nextEl.focus();
  };

  const handleKeyDown = (e, row, col) => {
    const height = grid.length;
    const width = grid[0] ? grid[0].length : 0;
    let nextRow = row;
    let nextCol = col;

    switch (e.key) {
      case "Enter":
      case "ArrowRight":
        do { nextCol++; } while (nextCol < width && !grid[nextRow][nextCol]);
        break;
      case "ArrowLeft":
        do { nextCol--; } while (nextCol >= 0 && !grid[nextRow][nextCol]);
        break;
      case "ArrowDown":
        do { nextRow++; } while (nextRow < height && !grid[nextRow][nextCol]);
        break;
      case "ArrowUp":
        do { nextRow--; } while (nextRow >= 0 && !grid[nextRow][nextCol]);
        break;
      default:
        return;
    }

    if (nextRow >= 0 && nextRow < height && nextCol >= 0 && nextCol < width && grid[nextRow][nextCol]) {
      const nextKey = `${nextRow}-${nextCol}`;
      const nextInput = document.getElementById(nextKey);
      if (nextInput) nextInput.focus();
    }

    e.preventDefault();
  };

  const checkAnswers = () => {
    grid.forEach((row, i) => {
      row.forEach((cell, j) => {
        if (cell) {
          const key = `${i}-${j}`;
          const el = document.getElementById(key);
          if (el) el.className = inputs[key] === cell.letter ? "correct" : "wrong";
        }
      });
    });
  };

  const highlightWord = (wordIndex) => {
    setHighlightedWord(wordIndex);
  };

  // Separar pistas em Across e Down
  const across = words.filter(w => w.start && w.horizontal).map(w => ({
    number: grid[w.start.row][w.start.col].number,
    clue: w.clue,
    index: w.index || words.indexOf(w)
  })).sort((a, b) => a.number - b.number);

  const down = words.filter(w => w.start && !w.horizontal).map(w => ({
    number: grid[w.start.row][w.start.col].number,
    clue: w.clue,
    index: w.index || words.indexOf(w)
  })).sort((a, b) => a.number - b.number);

  return (
    <div className="crossword-container">
      <div className="controls">
        <button onClick={() => setRefreshKey((k) => k + 1)}>🔄 Reiniciar Grade</button>
        <button onClick={checkAnswers}>✅ Verificar</button>
        <label>
          <input
            type="checkbox"
            checked={validationMode === "slow"}
            onChange={(e) => setValidationMode(e.target.checked ? "slow" : "manual")}
          />
          Validação Lenta
        </label>
      </div>

      <div className="grid">
        {grid.map((row, i) => (
          <div key={i} className="row">
            {row.map((cell, j) => (
              cell ? (
                <div className="cell" key={`${i}-${j}`}>
                  {cell.number && <span className="clue-number">{cell.number}</span>}
                  <input
                    id={`${i}-${j}`}
                    maxLength={1}
                    value={inputs[`${i}-${j}`] || ""}
                    onChange={(e) => handleChange(i, j, e.target.value)}
                    onKeyDown={(e) => handleKeyDown(e, i, j)}
                    className={cell.words.some(w => w.wordIndex === highlightedWord) ? "highlighted" : ""}
                  />
                </div>
              ) : (
                <div key={`${i}-${j}`} className="black-cell"></div>
              )
            ))}
          </div>
        ))}
      </div>

      <div className="clues">
        <h3>Horizontais (Across)</h3>
        <ul>
          {across.map((w) => (
            <li
              key={w.index}
              onClick={() => highlightWord(w.index)}
              style={{ cursor: "pointer" }}
            >
              <b>{w.number}.</b> {w.clue}
            </li>
          ))}
        </ul>
        <h3>Verticais (Down)</h3>
        <ul>
          {down.map((w) => (
            <li
              key={w.index}
              onClick={() => highlightWord(w.index)}
              style={{ cursor: "pointer" }}
            >
              <b>{w.number}.</b> {w.clue}
            </li>
          ))}
        </ul>
      </div>
    </div>
  );
};

export default CrosswordGame;